import { createSlice } from "@reduxjs/toolkit";
import { loadData } from "../../../functions/dataLoader";

let originData;

loadData("journeys.json").then((data) => (originData = data));

const scheduleModalToggleSlice = createSlice({
    name: "scheduleModalToggle",
    initialState: {
        value: {
            selected: undefined,
            desc: undefined,
            isActive: false,
        },
    },
    reducers: {
        setData: (state, action) => {
            state.value.selected = action.payload.data;
            state.value.desc = action.payload.desc;

            if (action.payload.data || action.payload.desc || state.value.selected) {
                state.value.isActive = true;
            }
        },
        inactive: (state) => {
            state.value.isActive = false;
        },
    },
});

export const { setData, inactive } = scheduleModalToggleSlice.actions;

export default scheduleModalToggleSlice.reducer;
